import Image from "./../image";
import ImageButton from "../button/image-button";
import { useLanguageStore } from "../../store/languageStore";
import { LanguageType, Language } from "../../types/language";
import { useTranslation } from "react-i18next";
import { filterAvailableVoiceNames } from "@/utils/speech";

interface LanguageSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  languageType: LanguageType;
  languageList: Language[];
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  isOpen,
  onClose,
  languageType,
  languageList,
}) => {
  const appLanguage = useLanguageStore((state) => state.appLanguage);
  const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);
  const setAppLanguage = useLanguageStore((state) => state.setAppLanguage);
  const setVoiceLanguage = useLanguageStore((state) => state.setVoiceLanguage);
  const setVoiceNames = useLanguageStore((s) => s.setVoiceNames);
  const { t, i18n } = useTranslation();

  if (!isOpen) return null;

  const currentLanguage = languageType === "app" ? appLanguage : voiceLanguage;
  const setLanguage =
    languageType === "app" ? setAppLanguage : setVoiceLanguage;

  const handleLanguageSelect = (languageCode: string) => {
    setLanguage(languageCode);

    if (languageType === "app") {
      i18n.changeLanguage(languageCode);
    } else if (languageType === "voice") {
      const availableVoices = filterAvailableVoiceNames(
        languageCode,
        (loadedVoices) => {
          setVoiceNames(loadedVoices);
        }
      );
      if (availableVoices && availableVoices.length > 0) {
        setVoiceNames(availableVoices);
      }
      console.log("set voices", availableVoices);
    }

    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-paper-gray rounded-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
        <div className="flex justify-between items-center mb-4 px-[20px] pt-[20px]">
          <h2 className="text-xl font-semibold primary-text-color">
            {languageType === "app" ? t("appLanguage") : t("voice")}
          </h2>
          <ImageButton
            onClick={onClose}
            src="/assets/icon_close.png"
            alt="selected"
            size={20}
            className="text-gray-500 hover:text-gray-700"
          />
        </div>

        <div className="flex-1 overflow-y-auto">
          {languageList.map((language) => (
            <button
              key={language.code}
              onClick={() => handleLanguageSelect(language.code)}
              className={`px-[20px] w-full text-left p-3 rounded flex items-center justify-between ${
                currentLanguage === language.code ? "bg-green-light" : ""
              }`}
            >
              <div className="font-medium primary-text-color">
                {language.name}
              </div>
              {currentLanguage === language.code ? (
                <Image
                  aria-hidden
                  src="/assets/icon_check.png"
                  alt="selected"
                  width={20}
                  height={20}
                />
              ) : null}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
